(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const storageKey = 'rive-social-proof-name';

    const updateSocialProofNames = () => {
      document.querySelectorAll('[data-rive-social-name]').forEach((element) => {
        if (element.dataset.riveNameReady === 'true') return;

        const names = element.dataset.riveFemaleNames.split('|').filter(Boolean);
        let previousName = '';

        try {
          previousName = sessionStorage.getItem(storageKey) || '';
        } catch (error) {
          previousName = '';
        }

        const availableNames = names.filter((name) => name !== previousName);
        const selectedNames = availableNames.length ? availableNames : names;
        const selectedName = selectedNames[Math.floor(Math.random() * selectedNames.length)];

        if (!selectedName) return;

        element.textContent = selectedName;
        element.dataset.riveNameReady = 'true';

        try {
          sessionStorage.setItem(storageKey, selectedName);
        } catch (error) {
          return;
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateSocialProofNames, { once: true });
    } else {
      updateSocialProofNames();
    }

    document.addEventListener('shopify:section:load', updateSocialProofNames);
  })();

  } catch(e) { console.error(e); }
})();
})();
